export const REQUEST_SUMMARY = 'request_summary' as const
export const SUCCESS_SUMMARY = 'success_summary' as const
export const FAILURE_SUMMARY = 'failure_summary' as const

export default {
  REQUEST_SUMMARY,
  SUCCESS_SUMMARY,
  FAILURE_SUMMARY
}
